<template>
  <BasicLayout>
    <template #wrapper>
      <el-card>
        <div slot="header" class="clearfix">
          <span>用户货币分布来源</span>
        </div>
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="类型" prop="level">
            <el-select v-model="queryParams.level" placeholder="请选择">
              <el-option
                v-for="item in rewardType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="用户ID" prop="type">
            <el-input
              v-model.number="queryParams.uid"
              placeholder="请输入用户ID"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
          <!--            <el-button icon="el-icon-refresh" size="mini" @click="exportData">导出</el-button>-->
          </el-form-item>
        </el-form>

        <currencySourcesStat ref="grand" :typ="'+'" />

        <currencySourcesStat ref="consume" :typ="'-'" />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getUserSourceStat } from '@/api/user/user_info'
import { getRidTypeList } from '@/api/config/reward-record'
import currencySourcesStat from '@/views/config/user/components/currency-sources-stat.vue'
import { getLastDates, scientificFormat } from '@/utils'
export default {
  name: 'CurrencySources',
  components: {
    currencySourcesStat
  },
  data() {
    return {
      total: 0,
      loading: false,
      rewardType: [
        { label: '金币', value: 14 },
        { label: '体力', value: 15 },
        { label: '钻石', value: 22 },
        { label: '野兽币', value: 65 },
        { label: '星星', value: 42 }
      ],
      reasonArr: [
        { label: '产出', value: '+' },
        { label: '消耗', value: '-' }
      ],
      queryParams: {
        startDate: '',
        endDate: '',
        level: 14,
        uid: '',
        country: '+'
      },
      ridData: {},
      tableData: []
    }
  },
  created() {
    const getUid = this.$route.query.uid
    const getType = this.$route.query.type
    if (getUid) {
      this.queryParams.uid = getUid
    }
    if (getType) {
      this.queryParams.level = parseInt(getType)
    }
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(7)
    }
    if (!this.queryParams.endDate) {
      this.queryParams.endDate = getLastDates(0)
    }
    this.getRidData()
    if (this.queryParams.startDate && this.queryParams.uid) {
      this.getTables()
    }
  },
  methods: {
    scientificFormat,
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      if (!this.queryParams.endDate) {
        this.msgError('请选择结束日期')
        return
      }
      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }
      this.getTables()
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables() {
      if (!this.queryParams.uid) {
        this.msgError('请选择用户ID')
        return
      }
      this.loading = true
      this.getTableData('+')
      this.getTableData('-')
      this.loading = false
    },
    getTableData(typ) {
      this.queryParams.country = typ
      getUserSourceStat(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data
          let sum = 0
          if (res.data.length) {
            res.data.forEach((item, index) => {
              let num = item.num
              if (this.type === 65) {
                num /= 10000
              }
              sum += num
              res.data[index].num = num
              res.data[index].ridStr = this.ridData[item.rid]
            })
          }
          if (typ === '+') {
            this.$refs.grand.refresh(this.tableData, sum)
          } else {
            this.$refs.consume.refresh(this.tableData, sum)
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getRidData() {
      getRidTypeList().then(res => {
        this.ridData = res.data
      })
    }
  }
}
</script>

<style scoped>
</style>
